import { atom } from "jotai";
import { Refresh } from "../types/refresh";

export const refreshAtomClients = atom<Refresh | null>(null);
